<script>
    import { required, minLength, numeric } from "vuelidate/lib/validators";
    import validationMessages from '@/components/validations'
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import Games from "@/services/Games";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    export default {
        props: ["pollData","groupOptions"],
        components:{
            validationMessages , vueDropzone: vue2Dropzone,flatPickr
        },
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                question:'',
                active_from:'',
                active_to:'',
                answers: [{ answer: "" }],
                min_answers: 0,
                image_url: "",
                pollId:null,
                active_to_time:'',
                active_from_time: '',
                photoDeletedCompanyImage : false ,
                photoDeletedLogoUrl : false ,
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                verified_checked: true,
                photoDeleted:false,
                imageStatus:false,
                recipient: '',
                selected_group_id: '',
                audienceOptions: [
                  { value: 'ALL', text: 'All users' },
                  { value: 'GROUP', text: 'User segment(group)' },
                ],
                datetimeconfig: {
                  enableTime: true,
                  time_24hr: true,
                  minuteIncrement: 1,
                  dateFormat: "Y-m-d H:i:S",
                },
                dropzoneOptions_primary: {
                    url: '/',
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    thumbnailWidth: 200,
                    thumbnailMethod: 'contain',
                    maxFilesize: 4,
                    acceptedFiles: 'image/jpeg,image/png,image/gif,image/bmp,image/webp',
                    maxFiles: 3,
                },
                dateconfig: {
                enableTime: false,
                dateFormat: "Y-m-d",
                
              },
              timeconfig: {
                enableTime: true,
                noCalendar: true,
                time_24hr: true,
                minuteIncrement: 1,
                dateFormat: "H:i",
                allowInput:true
              },
            };
        },
            validations: {
               question:{
                 required
               },
              active_from:{
                 required
              },
              active_from_time: {
                required
              },
              active_to:{
                 required
              },
                 active_to_time: {
                required
              },

            },
        computed: {
          hasGroupSelection() {
            return this.recipient === 'GROUP'
          },
        },
        methods: {
          syncData(){
            console.log(this.pollData);
            this.pollId = this.pollData.id;
            this.question = this.pollData.question;
            this.active_from = this.pollData.active_from;
            this.active_from_time = this.pollData.active_from.split(" ")[1];
            this.active_to_time = this.pollData.active_to.split(" ")[1];
            this.active_to = this.pollData.active_to;
            this.min_answers = this.pollData.min_answers;
            this.image_url = this.pollData.image;
            this.recipient = this.pollData.recipient;
            this.selected_group_id = this.pollData.group_id
            if(this.image_url === '' || this.image_url === null || this.image_url === undefined){
              this.photoDeleted = true;
            }
            console.log(this.active_from,'active from');

          },
          openDatePickerFrom() {
            this.$refs.datePickerFrom.$el.click();
          },
          openDatePickerTo(){
            this.$refs.datePickerTo.$el.click();
          },
            openTimePickerTo() {
            this.$refs.timePickerTo.$el.click();
          },
          openTimePickerFrom() {
            this.$refs.timePickerFrom.$el.click();
          },


            async addPoll(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                } else {
                   const formData = new FormData();
                   formData.append('question', this.question);
                   formData.append('active_from', `${this.active_from} ${this.active_from_time}:00`);
                   formData.append('active_to', `${this.active_to} ${this.active_to_time}:00`);
                   formData.append('min_answers', this.min_answers);
                   formData.append('image', this.image_url);
                   formData.append('recipient', this.recipient);
                   if(this.hasGroupSelection){
                     formData.append('group_id', this.selected_group_id);
                   }else{
                   formData.append('group_id', '');
                   }
                   formData.append('csrf_token', this.csrf_token);
                   formData.append('_method', 'PATCH');
                    try {
                        await Games.editPoll(this.pollId,formData).then((response) => {
                            this.successmsg("Changes has been saved");
                            this.closeModal();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error)
                        }).finally(() => {
                            this.refreshData();
                            this.tryingToEdit = false
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg(this.error)
                    }
                }
                this.tryingToEdit = false;
            },
            selectFileImageUrl(files) {
                setTimeout(() => {
                    let queuedFiles = this.$refs.myVueDropzone_image_url.getQueuedFiles();
                    if (queuedFiles.length > 1) {
                        this.failedmsg('You can only have one logo url');

                        files.forEach((value) => {
                            this.$refs.myVueDropzone_image_url.removeFile(value);
                        });


                    }
                    this.image_url = queuedFiles[0] || null;
                    this.photoDeleted = true;
                }, 250);
            },
            refreshData() {
                this.$emit('onRefresh')
            },
          closeModal() {
                this.showModal = false;
                this.resetProps()
            },
            deleteImage(){
              this.photoDeleted = true;
              this.image_url = "";
            },
            resetProps(){
                this.question = '';
                this.active_from = '';
                this.active_to = '';
                this.active_to_time = ''
                this.active_from_time = ''
                this.min_answers = 0;
                this.image_url = '';
                this.submitted = false;
                this.photoDeleted = false;
                this.recipient = '';
              this.selected_group_id = '';
            }
        },
    };
</script>

<template>
  <b-modal
    v-model="showModal"
    size="xl"
    @shown="syncData"
    @hidden="resetProps"
    id="edit_poll"
    hide-header
    hide-footer
    body-class="p-0"
    centered
  >
    <div class="poll-modal">

      <!-- HERO -->
      <header class="poll-modal__hero">
        <h2>Edit Poll Question</h2>
        <p>Update your poll question and settings</p>
      </header>

      <b-form @submit.prevent="addPoll">

        <!-- RECIPIENTS -->
        <section class="poll-card">
          <header class="poll-card__header">
            <h3>Recipients</h3>
            <p>Choose who can see this poll</p>
          </header>

          <b-form-group label="Target audience *" class="mb-0">
            <b-form-select
              v-model="recipient"
              :options="audienceOptions"
              :class="{ 'is-invalid': submitted && $v.recipient && $v.recipient.$error }"
            />
          </b-form-group>

          <b-form-group
            v-if="hasGroupSelection"
            label="User segment *"
            class="mt-4 mb-0"
          >
            <b-form-select
              v-model="selected_group_id"
              :options="groupOptions"
              placeholder="Select user segment"
            />
          </b-form-group>
        </section>

        <!-- POLL QUESTION + DATES -->
        <section class="poll-card">
          <header class="poll-card__header">
            <h3>Poll Question</h3>
            <p>Enter your poll question and select the active period</p>
          </header>

          <b-form-group label="Poll Question *" class="mb-4">
            <b-form-input
              v-model.trim="question"
              :class="{ 'is-invalid': submitted && $v.question.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Poll Question'"
              :validationName="$v.question"
            />
          </b-form-group>

          <div class="row g-3 flex-wrap">
            <!-- FROM -->
            <div class="col-12 col-lg-6">
              <div class="poll-datetime">
                <span class="poll-datetime__label">From</span>

                <div class="poll-datetime__inputs">
                  <div class="poll-input-icon">
                    <flat-pickr
                      ref="datePickerFrom"
                      v-model="active_from"
                      :config="dateconfig"
                      class="form-control pe-4"
                      :class="{ 'is-invalid': submitted && $v.active_from.$error }"
                    />
                    <i class="uil uil-calendar-alt poll-input-icon__icon"
                       @click="openDatePickerFrom"></i>
                  </div>

                  <div class="poll-input-icon">
                    <flat-pickr
                      ref="timePickerFrom"
                      v-model="active_from_time"
                      :config="timeconfig"
                      class="form-control pe-4"
                      :class="{ 'is-invalid': submitted && $v.active_from_time.$error }"
                    />
                    <i class="uil uil-clock poll-input-icon__icon"
                       @click="openTimePickerFrom"></i>
                  </div>
                </div>
              </div>
              <validationMessages
                v-if="submitted"
                :fieldName="'Active From'"
                :validationName="$v.active_from"
              />
              <validationMessages
                v-if="submitted"
                :fieldName="'Active From Time'"
                :validationName="$v.active_from_time"
              />
            </div>

            <!-- TO -->
            <div class="col-12 col-lg-6">
              <div class="poll-datetime">
                <span class="poll-datetime__label">To</span>

                <div class="poll-datetime__inputs">
                  <div class="poll-input-icon">
                    <flat-pickr
                      ref="datePickerTo"
                      v-model="active_to"
                      :config="dateconfig"
                      class="form-control pe-4"
                      :class="{ 'is-invalid': submitted && $v.active_to.$error }"
                    />
                    <i class="uil uil-calendar-alt poll-input-icon__icon"
                       @click="openDatePickerTo"></i>
                  </div>

                  <div class="poll-input-icon">
                    <flat-pickr
                      ref="timePickerTo"
                      v-model="active_to_time"
                      :config="timeconfig"
                      class="form-control pe-4"
                      :class="{ 'is-invalid': submitted && $v.active_to_time.$error }"
                    />
                    <i class="uil uil-clock poll-input-icon__icon"
                       @click="openTimePickerTo"></i>
                  </div>
                </div>
              </div>
              <validationMessages
                v-if="submitted"
                :fieldName="'Active To'"
                :validationName="$v.active_to"
              />
              <validationMessages
                v-if="submitted"
                :fieldName="'Active To Time'"
                :validationName="$v.active_to_time"
              />
            </div>
          </div>
        </section>

        <!-- IMAGE -->
        <section class="poll-card">
          <header class="poll-card__header">
            <h3>Poll Image</h3>
            <p>Upload an image for the poll (optional). Recommended: 910x350 pixels.</p>
          </header>

          <div class="poll-upload">
            <div v-if="!photoDeleted" class="poll-upload__preview">
              <img :src="image_url" alt="Poll" />
              <b-button
                variant="outline-danger"
                size="sm"
                class="poll-upload__delete"
                @click="deleteImage"
              >
                <i class="uil uil-trash-alt"></i> Remove
              </b-button>
            </div>
            <template v-else>
              <vue-dropzone
                ref="myVueDropzone_image_url"
                :use-custom-slot="true"
                :options="dropzoneOptions_primary"
                @vdropzone-files-added="selectFileImageUrl"
                no-progress-bar
              >
                <div class="poll-upload__placeholder">
                  <i class="uil uil-import"></i>
                  <span>Drag and drop an image, or click to browse</span>
                  <small>PNG, JPG, BMP, WEBP up to 4MB</small>
                </div>
              </vue-dropzone>
            </template>
          </div>
        </section>

        <!-- FOOTER -->
        <footer class="poll-modal__footer">
          <b-button variant="outline-secondary" @click="closeModal">
            Cancel
          </b-button>

          <b-button variant="dark" type="submit" :disabled="tryingToEdit">
            <b-spinner v-if="tryingToEdit" small class="me-2" />
            Save Changes
          </b-button>
        </footer>

      </b-form>
    </div>
  </b-modal>
</template>

<style scoped>
.poll-modal {
  padding: 32px;
  background: #f7f8fb;
}

.poll-modal__hero {
  margin-bottom: 24px;
}

.poll-modal__hero h2 {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 8px;
  color: #151a2d;
}

.poll-modal__hero p {
  margin: 0;
  color: #5f6b7d;
  font-size: 16px;
}

.poll-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: 0 12px 32px rgb(15 23 42 / 6%);
}

.poll-card__header h3 {
  margin-bottom: 4px;
  font-size: 20px;
  font-weight: 600;
  color: #151a2d;
}

.poll-card__header p {
  margin-bottom: 24px;
  color: #5f6b7d;
}

.poll-datetime {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.poll-datetime__label {
  font-weight: 600;
  color: #151a2d;
}

.poll-datetime__inputs {
  display: flex;
  gap: 12px;
  align-items: center;
}

.poll-input-icon {
  position: relative;
  flex: 1;
}

.poll-input-icon__icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #5f6b7d;
  font-size: 18px;
  cursor: pointer;
  pointer-events: auto;
}

.poll-input-icon .form-control {
  width: 100%;
}

.poll-datetime__inputs .form-control {
  padding: 12px 16px;
  border-radius: 12px;
  background: #f1f3f7;
  border: 1px solid transparent;
}

.poll-datetime__inputs .form-control:focus {
  border-color: #6366f1;
  background: #ffffff;
  box-shadow: none;
}

.poll-upload {
  border: 2px dashed #d3d8e6;
  border-radius: 16px;
  background: #f7f8fb;
  padding: 32px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.poll-upload.is-invalid {
  border-color: #f97373;
}

.poll-upload.has-error {
  border-color: #f97373;
  background: #fff5f5;
}

.poll-upload__preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.poll-upload__preview img {
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
}

.poll-upload__delete {
  margin-top: 8px;
}

.poll-upload__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #5f6b7d;
  font-size: 14px;
}

.poll-upload__placeholder i {
  font-size: 32px;
  color: #151a2d;
}

.poll-upload__placeholder small {
  color: #a0aec0;
}

.poll-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
}

@media (max-width: 767.98px) {
  .poll-modal {
    padding: 20px;
  }

  .poll-card {
    padding: 20px;
  }

  .poll-datetime__inputs {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>